var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bim-qmodel"},[_c('qmviewer',{attrs:{"modelName":_vm.name,"isCompont":_vm.isCompont,"isLocal":_vm.isLocal},on:{"callFather_loaded":_vm.callFather_loaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }